import React, { useContext } from 'react';
import { Context_UI } from '../../Contexts/Context_UI';
import UI_Radio from '../ERUMAUI/UI_Radio';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';

export default function Controls_Map_Floors({ Map_Composition }) {
    const UI = useContext(Context_UI);
    const {
        Selected_Building_Set,
        Selected_Building,
        Selected_Floor,
        Selected_Floor_Set
    } = useMapRenderer();

    const Building = Map_Composition?.[Selected_Building];
    const Floors = Building?.Floors || [];

    const HandleSelectFloor = (Floor) => {
        const floorIndex = Floors.findIndex(f => f._id === Floor._id);
        if (floorIndex !== -1) {
            Selected_Floor_Set(floorIndex);
        }
    };

    return (
        <div className="Controls_Map_Floor">
            {Floors.length > 0 ? (
                <UI_Radio
                    id="Controls_Map_Floor"
                    key={`Building_${Selected_Building}`}
                    Items={Floors.map((Floor) => ({
                        ID: Floor._id,
                        Text: Floor.Name,
                        Value: Floor
                    }))}
                    Selected={Floors[Selected_Floor]?._id}
                    onSelect={HandleSelectFloor}
                    Reverse={true}
                />
            ) : (
                "No floors."
            )}
        </div>
    );
}
